import React, {useEffect} from 'react';
import Switch from 'react-switch';
import { useSelector, useDispatch } from 'react-redux';
import { translation } from 'helpers/utilsHelper.js';
import S from './StyledBetSlipBonus.js';
import { TOGGLE_AKO_BONUS, TOGGLE_STF_BONUS, calculatePossibleWin } from 'betSlipActions.js';

const BetSlipBonus = ({ totalBonus, tax }) => {
    const bonus = totalBonus?.currentBonusValue || 0;
    const dispatch = useDispatch();

    const { customerApprovalCombinationBonusEnable, customerApprovalSTFBonusEnable } = useSelector(state => state.Auth.user) ?? {};

    const { activeTab, betSlips, toggleAKOBonus, toggleSTFBonus, isPending } = useSelector(state => state.BetSlip);
    const selectedPromotion = betSlips[activeTab].selectedPromotion;
    const isTaxFactorOfferActive = selectedPromotion?.offerType === "TAX_FACTOR_PROMOTION";

    const handleToggleAKO = () => {
        dispatch({ type: TOGGLE_AKO_BONUS, payload: { value: !toggleAKOBonus } });
    };

    const handleToggleSTF = () => {
        dispatch({ type: TOGGLE_STF_BONUS, payload: { value: !toggleSTFBonus } });
    };

    useEffect(() => {
        if (parseFloat(bonus) === 0 && toggleAKOBonus) {
            dispatch({ type: TOGGLE_AKO_BONUS, payload: { value: false } });
        }

        if (parseFloat(tax)=== app.config.defaultTaxFactor && toggleSTFBonus) {
            dispatch({ type: TOGGLE_STF_BONUS, payload: { value: false } });
        }
    }, [bonus, tax, dispatch]);

    useEffect(() => {
        dispatch(calculatePossibleWin(tax));
    }, [toggleAKOBonus, toggleSTFBonus, tax, dispatch]);

    const isAKOAvailable = parseFloat(bonus) > 0 && !!customerApprovalCombinationBonusEnable;
    const isSTFAvailable = parseFloat(tax) !== app.config.defaultTaxFactor && !!customerApprovalSTFBonusEnable && !isTaxFactorOfferActive && !isPending;

    return (
        <>
            {isAKOAvailable || isSTFAvailable ? (
                <S.BetSlipBonusWrapper>
                    {isAKOAvailable ? 
                        (
                            <S.BetSlipBonusOptionLabel>
                                <S.BetslipBonusLabel>{translation('betSlip_enableAKO')}</S.BetslipBonusLabel>
                                <Switch 
                                    height={20}
                                    width={40}
                                    onChange={handleToggleAKO}
                                    checked={toggleAKOBonus}
                                />
                            </S.BetSlipBonusOptionLabel>
                        )
                    : null}

                    {isSTFAvailable ?
                        <S.BetSlipBonusOptionLabel>
                            <S.BetslipBonusLabel>{translation('betSlip_enableSTF')}</S.BetslipBonusLabel>
                            <Switch 
                                height={20}
                                width={40}
                                onChange={handleToggleSTF}
                                checked={toggleSTFBonus}
                            />
                        </S.BetSlipBonusOptionLabel>
                    : null}
                </S.BetSlipBonusWrapper>
            ) : null}
        </>
    );
};

export default BetSlipBonus;